export default __webpack_public_path__ + "static/icon-tile-dark-2db2711f19e3d904cca93fd6049a6fdcb9b62d79421e07abc5afa1383d56feb7.png";